// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jumbo-card-extra-alt {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #1E40AF;
    border-radius: 20px;
    overflow: hidden;
    height: 480px;
}

.content-section-alt {
    color: white;
    padding: 40px;
    width: 60%; /* Default width for desktop */
    margin-bottom: 20px;
}

.logo-section-alt {
    width: 40%;
    height: 100%;
}

.header-text-alt {
    font-size: 28px;
    font-weight: bold;
    margin-bottom: 20px;
}

.body-text-alt {
    font-size: 16px;
    line-height: 1.5;
    margin-bottom: 20px;
}

.italic-text {
    font-style: italic;
    font-size: 12px;
    margin-top: 10px;
    margin-bottom: 20px;
}

.action-button-alt {
    padding: 12px 24px !important;
    margin-top: 28px !important;
    margin-bottom: 0; /* Remove spacing after the button */
    background-color: #f68b3d;
    color: white;
    border-radius: 8px;
    border: 2px solid white;
}

.action-button-alt:hover {
    background-color: #f58a3a;
}

@media (max-width: 768px) {
    /* Hide the gradient background on mobile */
    .logo-section-alt {
        display: none;
    }

    /* Show the Markel logo image on mobile and make it bigger */
    .mobile-markel-logo {
        display: block;
        width: 120px; /* Increase width on mobile */
        height: 60px;  /* Increase height on mobile */
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        margin: 0 auto 16px;
    }

    /* Full width for content on mobile */
    .content-section-alt {
        width: 100%;
        padding: 20px;
    }

    /* Font size and layout adjustments for mobile */
    .header-text-alt {
        font-size: 20px;
    }

    .body-text-alt {
        font-size: 14px;
        line-height: 1.4;
    }

    .italic-text {
        font-size: 12px;
        margin-bottom: 20px;
    }

    /* Adjust container height for small screens */
    .jumbo-card-extra-alt {
        flex-direction: column; /* Stack content vertically */
        height: auto; /* Allow height to adjust to content */
        padding: 20px; /* Add padding for breathing room */
    }

    /* Ensure button and other text are visible */
    .action-button-alt {
        width: 100%; /* Full width button on mobile */
        text-align: center;
    }

    /* Remove additional text hiding on mobile */
    .mobile-hidden {
        display: block;
    }
}

/* Extra small screens (max-width: 500px) */
@media (max-width: 500px) {
    /* Further reduce padding and font sizes */
    .content-section-alt {
        padding: 10px;
    }
    .header-text-alt {
        font-size: 18px;
    }
    .body-text-alt {
        font-size: 13px;
    }
    .italic-text {
        font-size: 11px;
    }
}`, "",{"version":3,"sources":["webpack://./src/blocks/JumboCardAlt.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,UAAU,EAAE,8BAA8B;IAC1C,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,2BAA2B;IAC3B,gBAAgB,EAAE,oCAAoC;IACtD,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,2CAA2C;IAC3C;QACI,aAAa;IACjB;;IAEA,4DAA4D;IAC5D;QACI,cAAc;QACd,YAAY,EAAE,6BAA6B;QAC3C,YAAY,GAAG,8BAA8B;QAC7C,wBAAwB;QACxB,4BAA4B;QAC5B,2BAA2B;QAC3B,mBAAmB;IACvB;;IAEA,qCAAqC;IACrC;QACI,WAAW;QACX,aAAa;IACjB;;IAEA,gDAAgD;IAChD;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA,8CAA8C;IAC9C;QACI,sBAAsB,EAAE,6BAA6B;QACrD,YAAY,EAAE,sCAAsC;QACpD,aAAa,EAAE,mCAAmC;IACtD;;IAEA,6CAA6C;IAC7C;QACI,WAAW,EAAE,gCAAgC;QAC7C,kBAAkB;IACtB;;IAEA,4CAA4C;IAC5C;QACI,cAAc;IAClB;AACJ;;AAEA,2CAA2C;AAC3C;IACI,0CAA0C;IAC1C;QACI,aAAa;IACjB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".jumbo-card-extra-alt {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background-color: #1E40AF;\n    border-radius: 20px;\n    overflow: hidden;\n    height: 480px;\n}\n\n.content-section-alt {\n    color: white;\n    padding: 40px;\n    width: 60%; /* Default width for desktop */\n    margin-bottom: 20px;\n}\n\n.logo-section-alt {\n    width: 40%;\n    height: 100%;\n}\n\n.header-text-alt {\n    font-size: 28px;\n    font-weight: bold;\n    margin-bottom: 20px;\n}\n\n.body-text-alt {\n    font-size: 16px;\n    line-height: 1.5;\n    margin-bottom: 20px;\n}\n\n.italic-text {\n    font-style: italic;\n    font-size: 12px;\n    margin-top: 10px;\n    margin-bottom: 20px;\n}\n\n.action-button-alt {\n    padding: 12px 24px !important;\n    margin-top: 28px !important;\n    margin-bottom: 0; /* Remove spacing after the button */\n    background-color: #f68b3d;\n    color: white;\n    border-radius: 8px;\n    border: 2px solid white;\n}\n\n.action-button-alt:hover {\n    background-color: #f58a3a;\n}\n\n@media (max-width: 768px) {\n    /* Hide the gradient background on mobile */\n    .logo-section-alt {\n        display: none;\n    }\n\n    /* Show the Markel logo image on mobile and make it bigger */\n    .mobile-markel-logo {\n        display: block;\n        width: 120px; /* Increase width on mobile */\n        height: 60px;  /* Increase height on mobile */\n        background-size: contain;\n        background-repeat: no-repeat;\n        background-position: center;\n        margin: 0 auto 16px;\n    }\n\n    /* Full width for content on mobile */\n    .content-section-alt {\n        width: 100%;\n        padding: 20px;\n    }\n\n    /* Font size and layout adjustments for mobile */\n    .header-text-alt {\n        font-size: 20px;\n    }\n\n    .body-text-alt {\n        font-size: 14px;\n        line-height: 1.4;\n    }\n\n    .italic-text {\n        font-size: 12px;\n        margin-bottom: 20px;\n    }\n\n    /* Adjust container height for small screens */\n    .jumbo-card-extra-alt {\n        flex-direction: column; /* Stack content vertically */\n        height: auto; /* Allow height to adjust to content */\n        padding: 20px; /* Add padding for breathing room */\n    }\n\n    /* Ensure button and other text are visible */\n    .action-button-alt {\n        width: 100%; /* Full width button on mobile */\n        text-align: center;\n    }\n\n    /* Remove additional text hiding on mobile */\n    .mobile-hidden {\n        display: block;\n    }\n}\n\n/* Extra small screens (max-width: 500px) */\n@media (max-width: 500px) {\n    /* Further reduce padding and font sizes */\n    .content-section-alt {\n        padding: 10px;\n    }\n    .header-text-alt {\n        font-size: 18px;\n    }\n    .body-text-alt {\n        font-size: 13px;\n    }\n    .italic-text {\n        font-size: 11px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
